import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen px-6 py-12 bg-richblack-900 text-richblack-25 max-w-4xl mx-auto  break-words overflow-x-hidden">
      <section className="mb-8">
        <h1 className="text-3xl font-semibold text-yellow-100 mb-6">
          Privacy Policy
        </h1>
        <p className="text-richblack-200 mb-4">
          Agnostic Edufin Private Limited ("Company"), based in Kolkata, is
          committed to protecting user privacy. This Privacy Policy applies to
          the website www.cntacademy.com and explains how user information is
          collected, used, and disclosed with consent. The policy ensures
          transparency in data handling and provides users with choices
          regarding their information.
        </p>
        <p className="text-richblack-200 mb-4">
          This Privacy Policy complies with GDPR (effective May 25, 2018). Any
          conflicting provisions are void. If you disagree with the terms,
          please refrain from using the website. For concerns, contact
          <a href="mailto:info@cntacademy.com" className="text-yellow-100">
            {" "}
            info@cntacademy.com
          </a>
          .
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          1. Definitions
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            a. “We”, “Our”, and “Us” shall mean and refer to the creators of
            this privacy policy.
          </li>
          <li>
            b. “You”, “Your”, “Yourself” and “User” shall mean and refer to
            natural and legal individuals who use the Website
          </li>
          <li>
            c. “Personal Information” shall mean and refer to any personally
            identifiable information that We may collect from You. For removal
            of any doubts, please refer to Clause 2.
          </li>
          <li>
            d. “Third Parties” refer to any website, company or individual apart
            from the User and the creator of this Website.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          2. Information We Collect
        </h2>
        <p className="text-richblack-200 mb-4">
          We are committed to respecting Your online privacy. We further
          recognize Your need for appropriate protection and management of any
          Personal Information You share with us. We may collect the following
          information:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            a. Personal data such as, but not limited to, Name, Address,
            Password, Email ID, Mobile Number, Educational Details,
            Qualification, college name, area of interest, references etc. This
            Privacy Policy also covers data collected from non-registered users,
            including browsing behaviour and pages viewed. Personal information
            provided by users is stored and used only as necessary to ensure a
            seamless, efficient, and personalized experience.
          </li>
          <li>b. To enable the provision of services opted for by you;</li>
          <li>
            c. To communicate necessary account and service-related information
            from time to time;
          </li>
          <li>d. To allow you to receive quality customer care services;</li>
          <li>e. To comply with applicable laws, rules and regulations</li>
        </ul>
        <p className="text-richblack-200 mb-4">
          The Company may share necessary information with third parties to
          fulfil service requests. Contact details may be used to send offers
          based on user interests and for internal service improvements. Users
          can opt out at any time via the ‘unsubscribe’ button or by emailing
          <a href="mailto:info@cntacademy.com" className="text-yellow-100">
            {" "}
            info@cntacademy.com
          </a>
          .
        </p>
        <p className="text-richblack-200 mb-4">
          The Company collects and stores search history, website usage, and
          payment-related information. All sensitive financial data is securely
          processed through encrypted payment gateways. Information is stored on
          company servers only while the user remains active and is deleted upon
          the expiration or withdrawal of usership.
        </p>
        <p className="text-richblack-200 mb-4">
          The Company uses financial information solely for transaction
          completion. Users can choose not to share specific data, opt out of
          certain services or features, and decline non-essential
          communications.
        </p>
        <p className="text-richblack-200 mb-4">
          Online transactions carry inherent risks, which users can mitigate by
          maintaining security practices, such as keeping login details
          confidential and reporting any suspicious activity to customer
          support.
        </p>
        <p className="text-richblack-200">
          Users have the right to access, modify, restrict, or object to the
          retention and use of their personally identifiable information at any
          stage.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          3. Accessing and Deleting Your Personal Information
        </h2>
        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Access to your personal information
        </h3>
        <p className="text-richblack-200 mb-4">
          Registered users can view the categories of personal information
          collected in the Profile section. Some sensitive data, like account
          passwords, may be withheld for security reasons.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Right to request deletion of your personal information
        </h3>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            Users can request the deletion of their personal information through
            the user settings section, the "Delete my account" link, or by
            emailing{" "}
            <a
              href="mailto:support@elearnmarkets.com"
              className="text-yellow-100"
            >
              support@elearnmarkets.com
            </a>
            . However, some data may be retained as required by law or for
            security, fraud prevention, compliance, or service-related purposes.
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Our Use of Your Information:
        </h3>
        <p className="text-richblack-200 mb-4">
          The information provided by You shall be used to User data is used for
          necessary communication, targeted marketing, surveys, and data
          analysis. It also helps improve services, develop new features, and
          analyse purchase and usage trends.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Information Collection and Use
        </h3>
        <p className="text-richblack-200 mb-4">
          We collect various types of information to enhance and improve our
          services.
        </p>

        <h4 className="text-lg font-semibold mb-2 text-richblack-5">
          Types of Data Collected
        </h4>
        <p className="text-richblack-200 mb-2 font-semibold">Personal Data:</p>
        <p className="text-richblack-200 mb-4">
          While using our services, users may be required to provide personally
          identifiable information, including but not limited to:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>Email address</li>
          <li>First and last name</li>
          <li>Phone number</li>
          <li>Address (State, Province, ZIP/Postal Code, City)</li>
          <li>Cookies and usage data</li>
        </ul>

        <p className="text-richblack-200 mb-2 font-semibold">Usage Data:</p>
        <p className="text-richblack-200 mb-4">
          We collect data sent by your browser or mobile device when accessing
          our services. This may include:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Pages visited, visit time, and duration</li>
          <li>Unique device identifiers and diagnostic data</li>
          <li>
            Mobile device details (model, operating system, browser type, and
            unique ID)
          </li>
        </ul>
        <p className="text-richblack-200 mb-4">
          This data helps analyse and enhance user experience and service
          performance.
        </p>

        <h4 className="text-lg font-semibold mb-2 text-richblack-5">
          Tracking & Cookies Data
        </h4>
        <p className="text-richblack-200 mb-4">
          We utilize cookies and similar tracking technologies, such as beacons,
          tags, and scripts, to monitor user activity and enhance our services.
          Cookies are small data files, often including an anonymous unique
          identifier, that are stored on a user’s device.
        </p>
        <p className="text-richblack-200 mb-4">
          Users can configure their browser settings to reject cookies; however,
          this may limit access to certain features of our services.
        </p>

        <h4 className="text-lg font-semibold mb-2 text-richblack-5">
          Types of Cookies Used:
        </h4>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>Session Cookies: Essential for service operation.</li>
          <li>Preference Cookies: Store user preferences and settings.</li>
          <li>Security Cookies: Enhance security measures.</li>
        </ul>

        <h4 className="text-lg font-semibold mb-2 text-richblack-5">
          Use of Data
        </h4>
        <p className="text-richblack-200 mb-2">
          CNT Trading Academy uses the collected data for various purposes:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2">
          <li>To provide and maintain the Service</li>
          <li>To notify you about changes to our Service</li>
          <li>
            To allow you to participate in interactive features of our Service
            when you choose to do so
          </li>
          <li>To provide customer care and support</li>
          <li>
            To provide analysis or valuable information so that we can improve
            the Service
          </li>
          <li>To monitor the usage of the Service</li>
          <li>To detect, prevent and address technical issues</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Transfer of Data
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>
            Your personal data may be transferred and stored on servers outside
            your jurisdiction, where data protection laws may differ. If you are
            located outside India and provide your information, it will be
            transferred and processed in India with your consent.
          </li>
          <li>
            CNT Trading Academy ensures that all reasonable security measures
            are in place to protect your data. No transfer will occur unless
            adequate safeguards are implemented to maintain data security and
            compliance with this Privacy Policy.
          </li>
        </ul>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Disclosure Of Data Legal Requirements
        </h3>
        <p className="text-richblack-200 mb-4">
          CNT Trading Academy may disclose your Personal Data in the good faith
          belief that such action is necessary to:
        </p>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>To comply with a legal obligation</li>
          <li>
            To protect and defend the rights or property of CNT Trading Academy
          </li>
          <li>
            To prevent or investigate possible wrongdoing in connection with the
            Service
          </li>
          <li>
            To protect the personal safety of users of the Service or the public
          </li>
          <li>To protect against legal liability.</li>
        </ul>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Security of Data
        </h3>
        <p className="text-richblack-200 mb-4">
          We prioritize the security of your data and implement
          industry-standard measures to protect it. However, no internet
          transmission or electronic storage method is entirely secure, and
          absolute protection cannot be guaranteed.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Service Providers & Analytics
        </h3>
        <p className="text-richblack-200 mb-4">
          We may engage third-party service providers to assist in delivering
          our services, analyzing usage, and improving functionality. These
          providers have access to personal data only for specified tasks and
          are bound by confidentiality.
        </p>
        <p className="text-richblack-200 mb-4">
          For analytics, we use Google Analytics and Firebase, which track and
          report website traffic and user interactions. Google may use this data
          for ad personalization. Users can opt out of certain Firebase features
          through device settings. For more details, refer to Google’s Privacy
          Policy.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          Analytics
        </h3>
        <p className="text-richblack-200 mb-2">
          We may use third-party Service Providers to monitor and analyze the
          use of our Service.
        </p>

        <p className="text-richblack-200 font-semibold mb-2">
          Google Analytics
        </p>
        <p className="text-richblack-200 mb-4">
          Google Analytics is a web analytics service offered by Google that
          tracks and reports website traffic. Google uses the data collected to
          track and monitor the use of our Service. This data is shared with
          other Google services. Google may use the collected data to
          contextualize and personalize the ads of its own advertising network.
          For more information on the privacy practices of Google, please visit
          the Google Privacy & Terms web page:{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-yellow-100 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy?hl=en
          </a>
        </p>

        <p className="text-richblack-200 font-semibold mb-2">Firebase</p>
        <p className="text-richblack-200 mb-4">
          Firebase is analytics service provided by Google Inc. You may opt-out
          of certain Firebase features through your mobile device settings, such
          as your device advertising settings or by following the instructions
          provided by Google in their Privacy Policy:{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-yellow-100 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy?hl=en
          </a>
          . We also encourage you to review the Google's policy for safeguarding
          your data:{" "}
          <a
            href="https://support.google.com/analytics/answer/6004245"
            className="text-yellow-100 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://support.google.com/analytics/answer/6004245
          </a>
          . For more information on what type of information Firebase collects,
          please visit the Google Privacy & Terms web page:{" "}
          <a
            href="https://policies.google.com/privacy?hl=en"
            className="text-yellow-100 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://policies.google.com/privacy?hl=en
          </a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Third-Party Links
        </h2>
        <p className="text-richblack-200 mb-4">
          Our service may include links to external websites not operated by us.
          We do not control or take responsibility for their content, privacy
          policies, or practices. Users are advised to review the privacy
          policies of any third-party sites they visit.
        </p>

        <h3 className="text-xl font-semibold mb-2 text-richblack-5">
          External Links on the Website
        </h3>
        <p className="text-richblack-200 mb-4">
          The website may contain advertisements and links to third-party
          websites or resources, over which we have no control. We are not
          responsible for their availability, content, or any losses incurred
          due to reliance on them. These third parties may have their own
          privacy policies, which users are advised to review. For a list of
          third-party links, users can request details via email at{" "}
          <a href="mailto:info@elearnmarkets.com" className="text-yellow-100">
            info@elearnmarkets.com
          </a>
          .
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Children's Privacy
        </h2>
        <p className="text-richblack-200 mb-4">
          Our service is not intended for individuals under 18. We do not
          knowingly collect their personal data. If a parent or guardian becomes
          aware of such data collection, they should contact us, and we will
          take immediate steps to delete the information.
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Password Security
        </h2>
        <p className="text-richblack-200 mb-4">
          You are solely responsible for maintaining the confidentiality of your
          password and account. Protect your password from unauthorized access
          by choosing it carefully and signing out after use. Do not share your
          login credentials with others. Any actions taken using your account,
          including financial transactions, are your responsibility. If your
          password is compromised, change it immediately and notify us of any
          unauthorized access.
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Managing Your Profile
        </h2>
        <p className="text-richblack-200 mb-4">
          After registration, you can review and update your profile
          information, except for your email ID. Changes can be made through the
          website. While we may not retain old information, some data may be
          kept for dispute resolution, troubleshooting, or legal compliance. If
          you find any incorrect or incomplete information, you are responsible
          for updating or correcting it. You may also request profile removal to
          prevent others from viewing it.
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Your Rights Regarding Personal Data
        </h2>
        <ul className="list-disc list-inside text-richblack-200 space-y-2 mb-4">
          <li>Request a copy of your personal data.</li>
          <li>Request corrections to inaccurate or outdated data.</li>
          <li>Withdraw consent for data processing at any time.</li>
          <li>Object to the processing of your personal data.</li>
          <li>Lodge a complaint with a supervisory authority.</li>
          <li>
            Obtain information on data transfers to third countries or
            international organizations.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Changes to Privacy Policy
        </h2>
        <p className="text-richblack-200 mb-4">
          We may update our Privacy Policy periodically. Any changes will be
          posted on this page, with prior notice via email or a prominent notice
          on our service. Users are encouraged to review the policy regularly,
          as changes become effective upon posting.
        </p>

        <h2 className="text-2xl font-semibold mb-2 text-richblack-5">
          Contact Us
        </h2>
        <p className="text-richblack-200">
          If you have any questions about this Privacy Policy, please contact
          us:
          <br />• By email:{" "}
          <a href="mailto:info@cntacademy.com" className="text-yellow-100">
            info@cntacademy.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
